import { dynamicLinksQueryOptions } from "api/queries/dynamicLinks";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { search: { page: number; page_size: number; path?: string } };

export const dynamicLinksQuery = ({ search: { path, ...pagination } }: QueriesInput) =>
  dynamicLinksQueryOptions({
    ...pagination,
    limit: pagination.page_size,
    ...(path ? { "q[path_eq]": path } : {}),
  });

export const queries = (input: QueriesInput): Array<WarmableQuery> => [dynamicLinksQuery(input)];
